import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { deleteSubscriptionFailed, deleteSubscriptionSuccessful } from '../actions';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* deleteSubscription(action) {
  try {
    const {
      id,
      body,
    } = action.payload;

    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions/${id}`;
    const dataResponse = yield makeRequest(url, { body }, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteSubscriptionSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteSubscriptionFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteSubscriptionFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
